import React from "react";
import { DescriptionFieldProps } from "@rjsf/utils";
import MarkdownView from "react-showdown";
import { Description } from "./__styles__/DescriptionFieldTemplate";

export const DescriptionFieldTemplate = (props: DescriptionFieldProps) => {
  const { description, id } = props;
  return (
    <Description id={id}>
      {typeof description === "string" ?
        <MarkdownView markdown={description} />
      : description}
    </Description>
  );
};
